import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_PEDIDO = [
  {
    module: 'PEDIDO',
    colunas: [
      {
        field: 'numero',
        active: true,
        removable: false
      },
      {
        field: 'pre_cadastro_nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'vendedor_apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'modelo_descricao',
        active: true,
        removable: true
      },
      {
        field: 'linha_montagem_descricao',
        active: true,
        removable: true
      },
      {
        field: 'data_hora',
        active: true,
        removable: true
      },
      {
        field: 'previsao_entrega',
        active: true,
        removable: true
      },
      {
        field: 'referencia',
        active: true,
        removable: true
      },
      {
        field: 'valor_unitario',
        active: true,
        removable: true
      },
      {
        field: 'quantidade',
        active: true,
        removable: true
      },
      {
        field: 'valor_total',
        active: true,
        removable: true
      },
      {
        field: 'eventos',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PEDIDO_RELACIONADO',
    colunas: [
      {
        field: 'numero_pedido',
        active: true,
        removable: false
      },
      {
        field: 'numeros_associados',
        active: true,
        removable: false
      },
      {
        field: 'linha_producao_descricao',
        active: true,
        removable: true
      },

      {
        field: 'modelo_descricao',
        active: true,
        removable: true
      },
      {
        field: 'vendedor_nome',
        active: true,
        removable: true
      },
      {
        field: 'qtd_solicitada',
        active: true,
        removable: true
      },
      {
        field: 'qtd_produzida',
        active: true,
        removable: true
      },
      {
        field: `valor_total`,
        active: true,
        removable: true
      },
      {
        field: 'ganho_bruto',
        active: true,
        removable: true
      },
      {
        field: 'custo_total',
        active: true,
        removable: true
      },
      {
        field: 'data_solicitacao',
        active: true,
        removable: true
      },
      {
        field: 'status',
        active: true,
        removable: true
      }
    ]
  },
] as IColunasSettingsUser[];
